import React from "react";
import { useLocation } from "react-router-dom";
import { NavLink } from "react-router-dom";
import {
  Logo,
  Step1,
  Step2,
  Step3,
  Good,
  Active2,
  Active3,
} from "../../assets";
import {
  authWrapper,
  formLogoWrapper,
  formMainWrapper,
  tabWrapper,
  persDesktop,
  learnDesktop,
  extrasDesktop,
  persMobile,
  learnMobile,
  extrasMobile,
  tabText,
} from "./layout.module.css";

const FormLayout = ({ children }) => {
  const location = useLocation();
  const page = location.hash.slice(1);
  return (
    <div className={authWrapper}>
      <header className={formLogoWrapper}>
        <NavLink to="/">
          <Logo />
        </NavLink>
        {page != "payment-success" && (
          <div className={tabWrapper}>
            <NavLink to="/application/#personal">
              <div className={tabText}>
                {page === "education" ||
                page === "learning" ||
                page === "extras" ? (
                  <img src={Good} alt="step" />
                ) : (
                  <img src={Step1} alt="step" />
                )}
                <p className={persDesktop}>Personal Data</p>
                {page === "personal" ? (
                  <p className={persMobile}>Personal Data</p>
                ) : (
                  <></>
                )}
              </div>
            </NavLink>

            <NavLink
              to={
                page === "extras"
                  ? "/application/#learning"
                  : "/application/#personal"
              }
            >
              <div className={tabText}>
                {page === "learning" ? (
                  <img src={Active2} alt="step" />
                ) : page === "extras" ? (
                  <img src={Good} alt="step" />
                ) : (
                  <img src={Step2} alt="step" />
                )}
                <p className={learnDesktop}>Career Path</p>
                {page === "learning" ? (
                  <p className={learnMobile}>Career Path</p>
                ) : (
                  <></>
                )}
              </div>
            </NavLink>
            <NavLink
              to={
                page === "extras"
                  ? "/application/#extras"
                  : "/application/#personal"
              }
            >
              <div className={tabText}>
                {page === "extras" ? (
                  <img src={Active3} alt="step" />
                ) : (
                  <img src={Step3} alt="step" />
                )}
                <p className={extrasDesktop}>Payment</p>
                {page === "extras" ? (
                  <p className={extrasMobile}>Payment</p>
                ) : (
                  <></>
                )}
              </div>
            </NavLink>
          </div>
        )}
      </header>
      <div className={formMainWrapper}>
        <div>{children}</div>
      </div>
    </div>
  );
};
export { FormLayout };
